import React, { useState } from 'react';
import { useAuth } from '../../../features/auth';
import { MainSidebar, useSidebar } from '../../../widgets/main-sidebar';
import { Topbar } from '../../../widgets/topbar';
import { Tabs } from '../../../shared/ui/Tabs';
import { AnalyticsSection } from '../../admin/ui/sections/AnalyticsSection';
import { DealTimeSection } from './sections/DealTimeSection';

type Tab = 'funnel' | 'deal-time';

const TABS = [
  { value: 'funnel' as Tab, label: 'Воронка продаж' },
  { value: 'deal-time' as Tab, label: 'Среднее время сделки' },
];

const AnalyticsPage: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const { toggle } = useSidebar();
  const [tab, setTab] = useState<Tab>('funnel');

  if (!currentUser) return null;

  return (
    <div id="app-screen">
      <Topbar
        user={currentUser}
        onLogout={logout}
        onSidebarToggle={toggle}
      />
      <div className="app-body">
        <MainSidebar isAdmin={currentUser.role === 'ADMIN'} isManager={currentUser.role === 'MANAGER'} />
        <div className="app-content adm-content">
          <Tabs tabs={TABS} active={tab} onChange={setTab} className="dt-page-tabs" />
          {tab === 'funnel' ? <AnalyticsSection /> : <DealTimeSection />}
        </div>
      </div>
    </div>
  );
};

export { AnalyticsPage };
